/**
 * Build mode, fixed at build time (see .webpack/webpack.base.js DefinePlugin).
 * The ONLY module allowed to read `process.env.OFFLINE_MODE`: everything else
 * imports `IS_OFFLINE_BUILD` from here (or from its viewer re-export,
 * viewer/src/AZmed/Config/buildMode.js).
 */

// The full `process.env.OFFLINE_MODE` path must stay written out: DefinePlugin
// substitutes text, so destructuring would yield undefined.
export const IS_OFFLINE_BUILD = process.env.OFFLINE_MODE === 'true';
